const apiVersion = 1

let config = {
  baseUrl: function() {
    return `${window.runtimeConfig.adminPortalApiUri}/api/v${apiVersion}`
  },
  axiosConfig: {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }
  }
}
export default config



// WEBPACK FOOTER //
// ./src/api/config.js